import React from 'react';
import ZoomDipendenzeTemplate from '../../components/template-uno-zoom';
import { getPropRel, getProp, getPropMarked } from '../utils';

const ZoomDipendenzePreview = (props) => {
  const title = getProp(props, 'title');
  const text = getPropMarked(props, 'text');
  const dipendenze = getPropRel(props, 'dipendenze', 'dipendenze') || [];
  return <ZoomDipendenzeTemplate title={title} text={text} dipendenze={dipendenze} />;
};

export default ZoomDipendenzePreview;
